import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { toast } from 'sonner';

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('tpu_cart')) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    localStorage.setItem('tpu_cart', JSON.stringify(items));
  }, [items]);

  const add = (p, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.id === (p.id || p.slug));
      if (ex)
        return prev.map((i) =>
          i.id === (p.id || p.slug) ? { ...i, qty: Math.min(i.qty + qty, 99) } : i
        );
      return [
        ...prev,
        { id: p.id || p.slug, name: p.name, sku: p.sku, price: p.price, qty, image: p.image, stock: p.stock },
      ];
    });
    toast.success(`${p.name} added to cart`);
    setOpen(true);
  };

  const setQty = (id, qty) =>
    setItems((prev) =>
      prev.map((i) => (i.id === id ? { ...i, qty: Math.max(1, Math.min(qty, 99)) } : i))
    );
  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => {
    setItems([]);
    setPromo(null);
  };

  const applyPromo = (code) => {
    if (code.trim().toUpperCase() === 'TPU10') {
      setPromo({ code: 'TPU10', rate: 0.1 });
      toast.success('Promo applied — 10% off your order');
      return true;
    }
    toast.error('That promo code is not valid');
    return false;
  };

  const value = useMemo(() => {
    const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
    const discount = promo ? subtotal * promo.rate : 0;
    const count = items.reduce((s, i) => s + i.qty, 0);
    return {
      items,
      add,
      setQty,
      remove,
      clear,
      count,
      subtotal,
      discount,
      promo,
      applyPromo,
      open,
      setOpen,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, open, promo]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}
